import Actions from '../actions/actions';
import ShopifyCRUDActions from '../actions/ShopifyCRUDActions';
import { ShopifyOauthToken } from '../model/ConnectionModel';
import { ShopifyModel, ShopifyRevenueResponse } from '../model/ShopifyModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  accounts: ShopifyOauthToken[];
  revenue: ShopifyRevenueResponse;
  id: number;
};

const initialState: ShopifyModel = {
  busy: false,
  accounts: [],
  revenue: {
    ordersCount: 0,
    totalSpent: 0,
  },
};

export const shopify = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case ShopifyCRUDActions.busyAction:
      return setBusy(state);

    case ShopifyCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case ShopifyCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        busy: false,
      };
    }

    case ShopifyCRUDActions.revokeAction: {
      if (action.id === null) {
        return {
          ...state,
          busy: false,
        };
      }
      return {
        ...state,
        busy: false,
        accounts: state.accounts.filter(acc => acc.id !== action.id),
      };
    }
    case ShopifyCRUDActions.retrieveRevenue: {
      return {
        ...state,
        revenue: action.revenue,
        busy: false,
      };
    }
    case ShopifyCRUDActions.resetStore: {
      return initialState;
    }
    case ShopifyCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
